import React, { createContext, useEffect, useState } from "react";
import { getEmployeeTCPRolesWithRootStations } from "../resources/EmployeeResource";
import {
    FORCE_INDUCT_ROLE,
    INDUCT_MANAGEMENT_PERMISSIONS_REGION,
    ROOT_STATIONS,
} from "../util/Constants";
import Loader from "../loader/Loader";
import { getRegion } from "../util/Util";

export const PermissionsContext = createContext();

const isValidTcpRole = (tcpRoles, roleToCheckForAccess) => {
    if (tcpRoles) {
        return roleToCheckForAccess.some((manager) =>
            tcpRoles.some((role) => role.includes(manager)),
        );
    }
    return false;
};

const isValidRootStation = (tcpStations, region) => {
    if (tcpStations && ROOT_STATIONS[region]) {
        return ROOT_STATIONS[region].some((rootStation) =>
            tcpStations.includes(rootStation),
        );
    }
    return false;
};

const isValidUserForAccess = (
    tcpRolesWithRootStations,
    region,
    roleToCheckForAccess
) => {
    if (tcpRolesWithRootStations && region) {
        region = region.toUpperCase();
        let stations = Object.keys(tcpRolesWithRootStations);
        if (isValidRootStation(stations, region)) {
            let rootStations = ROOT_STATIONS[region];
            const uniqueRoles = new Set();
            rootStations.forEach((station) => {
                const roles = tcpRolesWithRootStations[station];
                if (roles) {
                    roles.forEach((role) => {
                        uniqueRoles.add(role);
                    });
                }
            });
            if (uniqueRoles) {
                return isValidTcpRole([...uniqueRoles], roleToCheckForAccess);
            }
        }
        return false;
    }
    return false;
};

const PermissionsContextProvider = ({ children }) => {

    const [isUserAuthorisedForForceInduct, setIsUserAuthorisedForForceInduct] =
        useState(false);

    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        (async () => {
            const tcpRolesWithRootStationsResponse =
                await getEmployeeTCPRolesWithRootStations();

            const region = getRegion();

            let isAuthorizedForForForceInduct = isValidUserForAccess(
                tcpRolesWithRootStationsResponse,
                region,
                FORCE_INDUCT_ROLE
            );

            isAuthorizedForForForceInduct =
                isAuthorizedForForForceInduct || !INDUCT_MANAGEMENT_PERMISSIONS_REGION.includes(region);

            setIsUserAuthorisedForForceInduct(isAuthorizedForForForceInduct);
            setIsLoading(false);
        })();
    }, []);
    if (isLoading) return <Loader />;
    return (
        <PermissionsContext.Provider value={{ isUserAuthorisedForForceInduct }}>
            {children}
        </PermissionsContext.Provider>
    );
};

export default PermissionsContextProvider;


// WEBPACK FOOTER //
// ./src/components/permissions/PermissionsContext.js